import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import LessonTemplate from '../components/templates/Lesson';

const Lesson = () => {
  return <AuthWrapper renderProps={LessonTemplate} />;
};

export default Lesson;
